import React from 'react';
import { CheckIcon, ShieldCheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { checkoutLinks } from '../data/checkout';
import { SectionHeading } from './SectionHeading';
const mainIncludes = ['6 tomos principales para sala de 3, 4 y 5 años', '5 bonos especiales gratis', 'Efemérides, juegos, dinámicas y planificación anual'];
const packIncludes = ['Todo lo del MegaPack Seño Jardín', '6 tomos principales', '5 bonos especiales gratis', 'Sistema Sala en Armonía', 'Convivencia, calma y conducción de grupo para Nivel Inicial'];
export function PricingSection() {
  return <section id="precios" className="w-full bg-cream px-5 py-16 sm:py-20" aria-labelledby="pricing-title" style={{
    paddingTop: "0px"
  }} data-id="element-144" data-mp="1x8glruud9o4h">
      <div className="mx-auto max-w-2xl" data-id="element-145" data-mp="2271lzu9mc7sx">
        <SectionHeading id="pricing-title" title={<>
              Elegí <span className="underline-hand underline-hand-gold" data-id="element-147" data-mp="2ws4vn4krbhg">tu pack</span>
            </>} subtitle="Dos opciones · mismo acceso inmediato" data-id="element-146" data-mp="2uyxg5m50n8e" />

        <div className="mt-12 space-y-8" data-id="element-148" data-mp="1mgy5r1ujtmrm">
          {/* Oferta principal */}
          <article className="relative rounded-3xl border-2 border-forest-200 bg-white p-6 text-center shadow-card sm:p-8" data-id="element-149" data-mp="1hpy6vr1vcumh">
            <span className="absolute -top-3.5 left-1/2 -translate-x-1/2 whitespace-nowrap rounded-full bg-forest-100 px-3 py-1 font-display text-[10px] font-extrabold uppercase tracking-[0.18em] text-forest-700" data-id="element-150" data-mp="1cq3ko0t1gt7r">
              Oferta principal
            </span>

            <h3 className="mt-3 font-display text-2xl font-extrabold text-forest-800" data-id="element-151" data-mp="20gfzzwqm5s8d">
              MegaPack Seño Jardín
            </h3>
            <p className="mt-2 text-sm text-forest-900/70" data-id="element-152" data-mp="1vgbgryybmjeg">Los 6 tomos + 5 bonos especiales gratis</p>

            <ul className="mx-auto mt-6 max-w-sm space-y-2 text-left" data-id="element-153" data-mp="1repyfy30pcwv">
              {mainIncludes.map(item => <li key={item} className="flex items-start gap-2 text-[13px] text-forest-900/80" data-id="element-154" data-mp="k38z10khjnsp">
                  <CheckIcon className="mt-0.5 h-4 w-4 flex-none text-lime-600" aria-hidden="true" data-id="element-155" data-mp="fzjcshra9iau" />
                  {item}
                </li>)}
            </ul>

            <div className="mt-7 border-t-2 border-dashed border-forest-100 pt-6" data-id="element-156" data-mp="mgur9z3ju5m5">
              <p className="text-xs font-bold uppercase tracking-wider text-forest-900/50" data-id="element-157" data-mp="meia3o5m7za5">
                Precio normal: <span className="line-through" data-id="element-158" data-mp="cioo7e60atfp">ARS 49.000</span>
              </p>
              <p className="mt-2 text-[11px] font-extrabold uppercase tracking-[0.2em] text-lime-600" data-id="element-159" data-mp="ckrm0kdehquz">
                Hoy
              </p>
              <p className="font-display text-4xl font-extrabold text-forest-800 sm:text-5xl" data-id="element-160" data-mp="3iig67t2ulnx">
                ARS 19.990
              </p>
            </div>

            <CtaButton className="mt-6 w-full sm:w-auto" size="md" href={checkoutLinks.megapack} pixelContent="MegaPack Seño Jardín" pixelValue={19990} data-id="element-161" data-mp="3kwds8modhxkv">
              Quiero el MegaPack
            </CtaButton>

            <p className="mt-4 text-[11px] font-bold uppercase tracking-wider text-forest-900/50" data-id="element-162" data-mp="3c066p5x564ua">
              Pago seguro · Acceso inmediato · Garantía 7 días
            </p>
          </article>

          {/* 360 */}
          <article className="relative rounded-3xl border-4 border-gold-400 bg-forest-800 p-6 text-center text-cream shadow-lift sm:p-8" data-id="element-163" data-mp="2sca25cs4t6kx">
            <span className="absolute -top-4 left-1/2 -translate-x-1/2 whitespace-nowrap rounded-full bg-gold-400 px-3.5 py-1 font-display text-[10px] font-extrabold uppercase tracking-[0.18em] text-forest-900" data-id="element-164" data-mp="36cku6j56gr7o">
              Más elegido · mejor valor
            </span>

            <h3 className="mt-3 font-display text-2xl font-extrabold" data-id="element-165" data-mp="3bbnx9y1lknd0">
              MegaPack Seño Jardín <span className="text-gold-400" data-id="element-166" data-mp="3p2snk9j2s3ao">360</span>
            </h3>
            <p className="mt-2 text-sm text-cream/75" data-id="element-167" data-mp="3p43w0mngtz84">
              MegaPack principal + Sistema Sala en Armonía
            </p>
            <p className="mx-auto mt-4 max-w-md text-[13px] leading-relaxed text-cream/80" data-id="element-168" data-mp="2uj9vaiixo0m">
              La versión completa para seños que no solo quieren planificar mejor, sino también{' '}
              <span className="mark-lime-dark font-bold text-cream" data-id="element-169" data-mp="hym6uoeyd5ii">
                conducir la sala con más calma
              </span>
              , mejorar la convivencia y sentirse más seguras durante el año escolar.
            </p>

            <ul className="mx-auto mt-6 max-w-sm space-y-2 text-left" data-id="element-170" data-mp="qqxszy31a6so">
              {packIncludes.map(item => <li key={item} className="flex items-start gap-2 text-[13px] text-cream/85" data-id="element-171" data-mp="vozd8mc74c5q">
                  <CheckIcon className="mt-0.5 h-4 w-4 flex-none text-lime-400" aria-hidden="true" data-id="element-172" data-mp="3v5xkfg86rxf9" />
                  {item}
                </li>)}
            </ul>

            <div className="mt-7 border-t-2 border-dashed border-cream/20 pt-6" data-id="element-173" data-mp="7zdfm3bh24zu">
              <p className="text-xs font-bold uppercase tracking-wider text-cream/60" data-id="element-174" data-mp="cyzt8dv7pn96">
                Precio normal: <span className="line-through" data-id="element-175" data-mp="1jf1zgltfinwf">ARS 69.000</span>
              </p>
              <p className="mt-2 text-[11px] font-extrabold uppercase tracking-[0.2em] text-lime-200" data-id="element-176" data-mp="1jhfuwvs0u24i">
                Hoy
              </p>
              <p className="font-display text-4xl font-extrabold text-gold-400 sm:text-5xl" data-id="element-177" data-mp="38wgs765rgdoz">
                ARS 27.990
              </p>
            </div>

            <CtaButton className="mt-6 w-full sm:w-auto" size="md" href={checkoutLinks.megapack360} pixelContent="MegaPack Seño Jardín 360" pixelValue={29990} data-id="element-178" data-mp="33zgm4v8wvaxv">
              Llevar pack completo
            </CtaButton>

            <p className="mt-4 flex items-center justify-center gap-2 text-[11px] font-bold uppercase tracking-wider text-cream/65" data-id="element-179" data-mp="2q5fwcqzxsy9n">
              <ShieldCheckIcon className="h-4 w-4 text-lime-400" aria-hidden="true" data-id="element-180" data-mp="2l5l2qfos1ukw" />
              Pagás en pesos argentinos con Mercado Pago
            </p>
          </article>
        </div>
      </div>
    </section>;
}